import { render, staticRenderFns } from "./order-confirmation-form-selector.vue?vue&type=template&id=cb991348&"
import script from "./order-confirmation-form-selector.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-form-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports